import {replaceCommonJsonToTag, getParagraph, getParagraphForEdit, getExplain} from '@/utils/createRender'
import WEB_API from '@/API/api'

//可编辑解析
let reverseParseText = (data) => {
    let obj, parseTextData
    obj = createRender(data, 0);
    /**题干、图片、挖空、分组、解析**/
    let stem = {},
        stemStyle = {},
        blankList = [],
        groupList = [],
        imgDetail = {
            imgUrl: '',
            imgWidth: '',
            imgHeight: ''
        }

    Object.keys(obj).forEach(v => {
        if (v.indexOf('beforeImgParagraph') > -1) {
            /*处理图前段落部分*/
            stem[v] = obj[v];
        }
        if (v.indexOf("stemStyle") > -1) {
            /*处理段落样式*/
            stemStyle = obj[v];
        }
    })
    parseTextData = Object.assign(obj, {
        stem,
        stemStyle,
        well_chosen: data.well_chosen,//所属题包
        select: data.select,//知识点
        cateitem_list: data.cateitem_list,
        display_type: data.display_type,
    })
    return parseTextData
}

//展示解析
let reverseParseTextView = data => {
    let obj, parseTextData;
    obj = createRender(data);
    let stem = "",
        blankList = [],
        groupList = [],
        imgDetail = {
            imgUrl: '',
            imgWidth: '',
            imgHeight: ''
        }

    Object.keys(obj).forEach(val => {
        if (val.indexOf("beforeImgParagraph") > -1) {
            // 题干部分
            stem += obj[val];
        }
    })
    parseTextData = Object.assign(obj, {
        stem,
        well_chosen: data.well_chosen,//所属题包
        select: data.select,//知识点
        cateitem_list: data.cateitem_list,
        display_type: data.display_type,
    })
    return parseTextData
}

/*
*  创建枚举题的render
* */
function createRender(data, showType = 1) {
    let render = {};
    // 图片和挖空信息获取
    let {imgDetail, blankList, imgParagraph, imgStyle} = getImgBlankData(data.stem, showType);
    // 获取分组情况
    let groupList = data.answer ? getGroupList(data.answer) : []
    //解析的内容
    let explain = data.explain ? getExplain(data.explain) : ''

    render = Object.assign({}, {
        groupList,
        blankList,
        imgDetail,
        explain,
    }, imgParagraph, imgStyle);
    return render;
}

/*
*  解析分组和答案
* */
function getGroupList(answerStr) {
    let answer
    try {
        answer = JSON.parse(answerStr)
    } catch (err) {
        return {answer: '答案解析错误'}
    }

    let groupList = answer.map((v, i) => {
        let item = {
            groupIndex: i,
            answer: v.result,
            blank: v.blank_id.split('|'),
        }
        return item
    });
    ;

    return groupList;
}


function getImgBlankData(str, showType) {
    /*
    *  获取图片和挖空的信息
    * */
    let result = replaceCommonJsonToTag(str),
        imgInfo = '',
        blankList = [],
        imgDetail = {},
        imgParagraph = {},
        imgStyle = {
            stemStyle: {}
        };

    let reg_stem = /#\{"type":"para_begin","style":"math_fill_image"\}#(.*?)#\{"type":"para_end"\}#/ig;
    let firstRes = reg_stem.exec(result);
    if (!firstRes) return {};

    imgInfo = firstRes[1].replace(/(#)/g, "");

    let par = str.split(`#{"type":"para_begin","style":"math_fill_image"}#${firstRes[1]}#{"type":"para_end"}#`);
    //图前段落
    if (par[0].length > 1) {
        if (showType === 0) {// 匹配 stem
            let {paragraph, style} = getParagraphForEdit(par[0], 'beforeImgParagraph');
            Object.assign(imgParagraph, paragraph);
            style && style['style'] && Object.assign(imgStyle['stemStyle'], JSON.parse(style['style']));
        } else {
            let {paragraph, style} = getParagraph(par[0], 'beforeImgParagraph');
            Object.assign(imgParagraph, paragraph);
            style && ['style'] && Object.assign(imgStyle['stemStyle'], JSON.parse(style['style']));
        }
    }


    /*
    *  解析图片挖空坐标
    * */
    let parseImgData = JSON.parse(imgInfo);
    imgDetail = {
        imgUrl: parseImgData.src,
        imgHeight: parseImgData.height,
        imgWidth: parseImgData.width,
        imgInitWidth: parseImgData.imgInitWidth,
        imgInitHeight: parseImgData.imgInitHeight,
    }

    imgDetail.imgInitWidth = parseImgData.imgInitWidth ? parseImgData.imgInitWidth : parseImgData.width
    imgDetail.imgInitHeight = parseImgData.imgInitHeight ? parseImgData.imgInitHeight : parseImgData.height
    blankList = parseImgData.blanklist.map((v, i) => {

        let item = {
            x: parseInt(v.x_pos / 100 * parseInt(imgDetail.imgInitWidth.replace('px'))),
            y: parseInt(v.y_pos / 100 * parseInt(imgDetail.imgInitHeight.replace('px'))),
            blankIndex: i + 1,
            size: v.size,
            isUse: true
        }
        return item
    });
    return {imgDetail, blankList, imgParagraph, imgStyle};
}


export {reverseParseText, reverseParseTextView}


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/enumeration/createRender.js